<template>
  <div class="experOption">
    <div class="experOption_top">
      <el-cascader
        style="margin-right: 20px"
        placeholder="请选择班级"
        :options="classList"
        :show-all-levels="false"
        :props="classProp"
        clearable
        v-model="experParams.classid"
        @change="GetExperOperateRecord"
      ></el-cascader>
      <el-cascader
        :options="experList"
        placeholder="请选择实验"
        :show-all-levels="false"
        :props="experProp"
        clearable
        v-model="experParams.experimentid"
        @change="GetExperOperateRecord"
      ></el-cascader>
      <el-date-picker
        style="margin-left: 20px"
        v-model="selectDate"
        type="datetimerange"
        @change="dateChange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
    </div>
    <div class="experOption_body">
      <el-table
        :data="experTableData"
        stripe
        tooltip-effect="dark"
        style="width: 100%"
        empty-text="请选择班级实验"
        :default-sort="{ prop: 'date', order: 'descending' }"
      >
        <el-table-column type="index" label="序号" width="80" align="center">
        </el-table-column>

        <el-table-column prop="username" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="usercode" label="学号" align="center">
        </el-table-column>
        <el-table-column prop="alltime" label="操作用时" align="center">
        </el-table-column>
        <el-table-column prop="operacount" label="次数" align="center">
        </el-table-column>
        <el-table-column prop="finishcount" label="完成次数" align="center">
        </el-table-column>
        <el-table-column prop="finishrate" label="完成率" align="center">
        </el-table-column>
        <el-table-column
          sortable
          prop="createdate"
          label="创建时间"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 实验报告详情 -->
      <el-dialog
        title="实验操作详情"
        :visible.sync="dialogVisible"
        width="45%"
        top="50px"
      >
        <el-tabs
          v-model="activeName"
          type="border-card"
          @tab-click="TabhandleClick"
        >
          <el-tab-pane label="实验过程" name="first">
            <el-table :data="expStepData" style="width: 100%">
              <el-table-column
                label="序号"
                type="index"
                width="80"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="itemname" align="center" label="操作步骤">
                <template slot-scope="scope">
                  第{{ scope.row.stepnum }}-{{ scope.row.sortcode }}步：{{
                    scope.row.itemname
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="operatetime"
                label="用时"
                align="center"
                width="100"
              >
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="实验报告" name="second" class="secondBox">
            <div class="reportBox">
              <span class="reportBox_tit">指导老师：</span>
              <span>{{
                expReportData.teachername == null
                  ? ""
                  : decodeURI(expReportData.teachername)
              }}</span>
            </div>
            <div class="reportBox">
              <span class="reportBox_tit">实验人员：</span>
              <span>{{
                expReportData.participants == null
                  ? ""
                  : decodeURI(expReportData.participants)
              }}</span>
            </div>
            <div class="reportBox">
              <span class="reportBox_tit">实验名称：</span>
              <span>{{
                expReportData.experimentname == null
                  ? ""
                  : decodeURI(expReportData.experimentname)
              }}</span>
            </div>
            <div class="reportBox">
              <span class="reportBox_tit">实验目的：</span>
              <span>{{
                expReportData.purpose == null
                  ? ""
                  : decodeURI(expReportData.purpose)
              }}</span>
            </div>
            <div class="reportBox">
              <span class="reportBox_tit">实验原理：</span>
              <span>{{
                expReportData.principle == null
                  ? ""
                  : decodeURI(expReportData.principle)
              }}</span>
            </div>
            <div class="reportBox">
              <span class="reportBox_tit">实验对象：</span>
              <span>{{
                expReportData.objects == null
                  ? ""
                  : decodeURI(expReportData.objects)
              }}</span>
            </div>
            <div class="reportBox">
              <span class="reportBox_tit">实验器材：</span>
              <span>{{
                expReportData.quipment == null
                  ? ""
                  : decodeURI(expReportData.quipment)
              }}</span>
            </div>
            <div class="reportBox">
              <span class="reportBox_tit">药品试剂：</span>
              <span>{{
                expReportData.reagent == null
                  ? ""
                  : decodeURI(expReportData.reagent)
              }}</span>
            </div>
            <div class="reportBox">
              <span class="reportBox_tit">实验步骤：</span>
              <span>{{
                expReportData.step == null ? "" : decodeURI(expReportData.step)
              }}</span>
            </div>
            <!-- <div>
                  <span>实验结果</span>
                  <span>{{expReportData.result}}</span>
                </div> -->
            <div class="reportBox">
              <span class="reportBox_tit">实验讨论：</span>
              <span>{{
                expReportData.discuss == null
                  ? ""
                  : decodeURI(expReportData.discuss)
              }}</span>
            </div>
            <div class="reportBox">
              <span class="reportBox_tit">实验结论：</span>
              <span>{{
                expReportData.conclusion == null
                  ? ""
                  : decodeURI(expReportData.conclusion)
              }}</span>
            </div>
            <div class="reportBox">
              <span class="reportBox_tit">教师点评：</span>
              <span>
                <el-input
                  style="width: 80%; position: relative; top: 5px"
                  v-model="expReportData.comment"
                  autosize
                  type="textarea"
                  placeholder="请输入点评内容"
                ></el-input>
              </span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
      <div>
        <el-pagination
          style="text-align: center; margin-top: 20px"
          :hide-on-single-page="true"
          :total="total"
          :page-size="experParams.pagesize"
          :current-page.sync="experParams.pageindex"
          @current-change="GetExperOperateRecord"
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../../api/index";
import moment from "moment";
moment.locale("zh-cn");

export default {
  data() {
    return {
      classList: [],
      experList: [],
      experProp: {
        label: "itemname",
        value: "itemid",
        children: "children",
        expandTrigger: "hover",
        emitPath: false,
      },
      classProp: {
        label: "orgname",
        value: "orgid",
        children: "children",
        expandTrigger: "hover",
        emitPath: false,
      },
      total: 0,
      selectDate: "",
      experParams: {
        classid: "",
        experimentid: "",
        startdate: "",
        enddate: "",
        pageindex: 1,
        pagesize: 13,
      },
      operaterecordid: "",
      experTableData: [],
      dialogVisible: false,
      activeName: "first",
      expStepData: [],
      expReportData: {},
    };
  },
  created() {
    this.GetUserSpecClassData();
    this.GetExperOperateRecord();
    this.GetExperTree();
  },
  methods: {
    //时间转换
    formatSeconds(value) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s = Math.floor(result % 60);

      let res = "";
      if (h !== "00") res += `${h}时`;
      if (m !== "00") res += `${m}分`;
      res += `${s}秒`;
      return res;
    },
    //获取班级列表
    async GetUserSpecClassData() {
      const res = await Api.userinfo.GetUserSpecClassData();
      this.classList = res.rows.orglist;
    },
    //获取实验列表
    async GetExperTree() {
      const res = await Api.sum.GetExperTree();
      this.experList = res.rows;
    },
    dateChange(e) {
      this.experParams.startdate = e != null ? e[0] : "";
      this.experParams.enddate = e != null ? e[1] : "";
      this.GetExperOperateRecord();
    },
    //学习实验操作记录
    async GetExperOperateRecord() {
      console.log(this.experParams);
      const res = await Api.sum.GetExperOperateRecord(this.experParams);
      if (res.success != true) return this.$message.info(res.msg);
      this.experTableData = res.rows;
      this.total = res.total;
      console.log(res);

      for (let i = 0; i < this.experTableData.length; i++) {
        const element = this.experTableData[i];
        element.finishrate = Math.round(element.finishrate * 100) + "%";
        console.log(element.alltime);
        element.alltime = this.formatSeconds(element.alltime);
      }
    },
    //查看实验报告btn
    async handleClick(e) {
      this.operaterecordid = e.operaterecordid;
      console.log(e);

      const res = await Api.sum.GetExperOperSteps(e.operaterecordid);
      if (res.success != true) return this.$message.info(res.msg);
      this.expStepData = res.rows;
      for (let i = 0; i < this.expStepData.length; i++) {
        const element = this.expStepData[i];
        element.operatetime = this.formatSeconds(element.operatetime);
      }
      this.activeName = "first";
      this.dialogVisible = true;
    },
    //tab分栏
    async TabhandleClick(tab, event) {
      if (tab.name == "second") {
        //查看对应实验的实验报告
        const res = await Api.sum.GetExperCheckRport(this.operaterecordid);
        this.expReportData = res.rows[0];
        if (res.success != true) return this.$message.info(res.msg);
      }
    },
  },
};
</script>
<style lang='less' scoped>
.experOption {
  width: 100%;
  height: 100%;
  background: #fff;
  .experOption_top {
    padding: 15px;
  }
  .secondBox {
    padding: 10px 20px 10px 50px;
    .reportBox {
      padding: 10px 0;
      font-size: 15px;
      .reportBox_tit {
        margin-right: 20px;
        font-weight: 600;
      }
    }
  }
  /deep/.el-dialog {
    border-radius: 7px;
    .el-dialog__header {
      margin: 0 20px;
      border-bottom: 1px solid #ccc;
    }
  }
}
</style>